var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ModalContainer'),_c('div',{staticClass:"logo-container"},[_c('a',{attrs:{"href":"/"}},[_c('Logo',{staticClass:"logo"})],1)]),_c('main',[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }